import React from 'react';
import { reduxForm, Field } from 'redux-form';
import CustomTextField from '../common/custom-components/customTextField';
import PropTypes from 'prop-types';
import { required, number, code } from '../../constants/constants';
import InfoMessageBar from '../common/info-message/info-message';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import './register.css';
export const ConfirmRegistrationForm = ({
  errors,
  handleSubmit,
  handleResendConfirmCode,
  handleBack,
  invalid,
  submitting,
  pristine,
  email,
}) => {
  return (
    <div className="auth-page" style={{ backgroundColor: '#F7F8F9' }}>
      <div className="container page">
        <div className="row">
          <div className="col-md-6 offset-md-3 col-xs-12">
            {errors && (
              <InfoMessageBar
                icColor="errorIc"
                variant="error"
                message={errors}
              />
            )}
            <Card boxShadow={3}>
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <CardContent>
                  <Typography
                    variant="h6"
                    className="text-xs-center"
                    color="primary"
                    gutterBottom
                    style={{ fontFamily: 'roman', fontSize: 26 }}
                  >
                    Check your email
                  </Typography>
                  <Typography
                    variant="body2"
                    component="p"
                    className="text-xs-center"
                  >
                    Enter the confirmation code we sent you to confirm your
                    account.
                  </Typography>
                  {email !== undefined && (
                    <Typography
                      variant="body2"
                      component="p"
                      className="text-xs-center"
                    >
                      Email Sent to: {email}
                    </Typography>
                  )}
                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="code"
                    symbol="Code"
                    placeholder="Confirmation Code"
                    required
                    fullWidth
                    type="text"
                    validate={[required, number, code]}
                    variant="outlined"
                  />
                  <div className="link-position">
                    <Link
                      component="button"
                      variant="body2"
                      alignText="center"
                      onClick={handleResendConfirmCode}
                      style={{
                        fontSize: 20,
                        fontFamily: 'Arial',
                      }}
                    >
                      Didn&apos;t receive a code
                    </Link>
                  </div>
                </CardContent>
                <div className="botton-confirm-group">
                  <Button
                    variant="contained"
                    color="primary"
                    className="btn btn-lg "
                    disabled={invalid || submitting || pristine}
                    type="submit"
                    fullWidth
                  >
                    CONFIRM
                  </Button>
                  <div className="back-link">
                    <Link
                      component="button"
                      variant="body2"
                      alignText="center"
                      onClick={handleBack}
                      style={{
                        fontSize: 20,
                        fontFamily: 'Arial',
                      }}
                    >
                      BACK
                    </Link>
                  </div>
                </div>
              </form>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmRegistrationForm.propTypes = {
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  handleResendConfirmCode: PropTypes.func,
  handleBack: PropTypes.func,
  invalid: PropTypes.func,
  submitting: PropTypes.func,
  pristine: PropTypes.func,
  email: PropTypes.string,
};

export default reduxForm({
  form: 'confirmRegisterForm',
  // a unique identifier for this form
})(ConfirmRegistrationForm);
